import { render, staticRenderFns } from "./UserSetupV1.vue?vue&type=template&id=117d8922&"
import script from "./UserSetupV1.vue?vue&type=script&lang=js&"
export * from "./UserSetupV1.vue?vue&type=script&lang=js&"
import style0 from "./UserSetupV1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports